import _ from 'lodash'
import moment from 'moment'

export const HOUR_LABEL_FORMAT = 'h:mma'
export const HOUR_FORMAT = 'H:mm'

export const HOUR_OPTIONS = _.range(24)
  .reduce((result, hour) => {
    const normalizedHour = hour < 10 ? `0${hour}` : hour.toString()
    const topValue = normalizedHour + `:00`
    const midValue = normalizedHour + `:30`
    result.push({
      value: moment(topValue, HOUR_FORMAT),
      label: moment(topValue, HOUR_FORMAT).format(HOUR_LABEL_FORMAT),
    })
    result.push({
      value: moment(midValue, HOUR_FORMAT),
      label: moment(midValue, HOUR_FORMAT).format(HOUR_LABEL_FORMAT),
    })
    return result
  }, [])
  .concat([{ value: moment('23:59:00', HOUR_FORMAT), label: '11:59pm' }])
